import { useState, useEffect } from "react";
import { Link as ScrollLink } from "react-scroll";
import style from "./NavBar.module.css";

function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth > 768 && isOpen) {
        setIsOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isOpen]);

  // Handle scroll for navbar background change
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Monitor active section based on scroll position
  useEffect(() => {
    const handleSectionScroll = () => {
      const sections = ["home", "about", "parent_div_id", "contact"];
      const scrollPosition = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleSectionScroll);
    return () => window.removeEventListener('scroll', handleSectionScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const navItems = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "parent_div_id", label: "Projects" },
    { id: "contact", label: "Contact" }
  ];

  return (
    <nav className={`${style.navbar} ${scrolled ? style.scrolled : ""}`}>
      <div className={style.container}>
        <div className={style.logo}>
          <ScrollLink to="home" smooth={true} duration={500} className={style.logo_link}>
            <span className={style.logo_text}>Pramod</span>
            <span className={style.logo_dot}>.</span>
          </ScrollLink>
        </div>
        
        <div className={`${style.hamburger} ${isOpen ? style.active : ""}`} onClick={toggleMenu}>
          <span className={style.bar}></span>
          <span className={style.bar}></span>
          <span className={style.bar}></span>
        </div>
        
        <ul className={`${style.nav_menu} ${isOpen ? style.active : ""}`}>
          {navItems.map((item) => (
            <li key={item.id} className={style.nav_item}>
              <ScrollLink
                to={item.id}
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                className={`${style.nav_link} ${activeSection === item.id ? style.active_link : ""}`}
                onClick={() => setIsOpen(false)}
              >
                {item.label}
              </ScrollLink>
            </li>
          ))}
          <li className={style.nav_button}>
            <a href="/resume.pdf" target="_blank" rel="noopener noreferrer" className={style.resume_button}>
              Resume
            </a>
          </li>
        </ul>
      </div>
      
      {isOpen && <div className={style.backdrop} onClick={() => setIsOpen(false)}></div>}
    </nav>
  );
}

export default NavBar;